import { Criterion } from './criterions/Criterion';

export enum AnalysisPage {
    MM01 = 1,
    MM02 = 2,
    MM03 = 3,
    MM04 = 4,
    MM05 = 5,
    MM06 = 6,
    MM07 = 7,
    MM08 = 8,
    MM09 = 9,
    MM10 = 10,
    MM11 = 11,
    MM12 = 12,
    MM13 = 13,
    HEADER = 14,
    OVERVIEW = 15,
    PREVIEW = 16
}

export namespace AnalysisPage {
    export function getCriterion(page: AnalysisPage): Criterion | null {
        if (page >= Criterion.MM01 && page <= Criterion.MM13) {
            return page as unknown as Criterion;
        }
        return null;
    }
}
